// Source keys preserve the original mixed-language Chinese interface exactly.
export default {
  独立单边论证: 'Isolated single argument',
  删除属性: 'Delete facet',
  '属性已从当前文章删除。': 'Facet deleted from this document.',
  '仅删除当前文章的此属性、提取结果及相关 Motif 条件，其他文章不受影响。':
    'Deletes this facet, its extracted values and related Motif constraints from this document only. Other documents are unaffected.',
  尚无段落摘要: 'No paragraph summary yet',
  '展开为 Unit': 'Expand to units',
  折叠为段落: 'Collapse to paragraphs',
  类型: 'Type',
  '脚本提取时间、地点和人物': 'Extracting time, places and people',
  生成单元短标签: 'Summarizing argument units',
  生成段落摘要: 'Summarizing paragraphs',
  按完整句子划分论证单元: 'Grouping complete sentences into argument units',
  判断节点类型: 'Classifying nodes',
  判断段落关系: 'Analyzing paragraph relations',
  判断论证单元关系: 'Analyzing argument unit relations',
  '计算单元 Embedding': 'Computing unit embeddings',
  '匹配 Motif': 'Matching motifs',
  构建初始图: 'Build initial graph',
  '更新 Schema': 'Update Schema',
  '更新 Facet': 'Update Facet',
  '更新 Motif': 'Update Motif',
  '拆分 Markdown，构建段落图与段内单元图，提取实体及向量':
    'Parse Markdown, build paragraph and internal unit graphs, extract entities and vectors',
  按变更的节点和关系定义更新受影响数据: 'Update data affected by node and link definitions',
  '只更新新增或修改的属性列，并汇总到段落':
    'Update added or changed attributes and aggregate them into paragraphs',
  匹配新增或修改的子图模式: 'Match added or changed subgraph patterns',
  焦点相关性: 'Focus relevance',
  '正在计算相关性…': 'Calculating relevance\u2026',
  相关性阈值: 'Relevance threshold',
  '已选 {count} 个候选单元': '{count} candidate units selected',
  分析焦点关系: 'Analyze focus links',
  查看候选及分数: 'Candidates and scores',
  提取方式: 'Extraction method',
  本地实体脚本: 'Local entity script',
  'Facet Agent · 按定义提取属性': 'Facet Agent \u00b7 Extract defined attributes',
  '词表脚本 · 精确匹配': 'Dictionary script \u00b7 Exact matching',
  多个词以逗号分隔: 'Separate terms with commas',
  '添加后提取各单元的属性并汇总到段落。':
    'Adding extracts attributes for each unit and aggregates them into paragraphs.',
  '保存后点击“更新 Facet”应用修改。': 'Save, then click Update Facet to apply changes.',
  '属性值，留空表示存在该属性': 'Attribute value; leave blank to match any value',
  '关系 {0} 类型': 'Relation {0} type',
  请先构建初始图: 'Build the initial graph first',
  '定义已保存，点击对应更新按钮应用。': 'Definition saved. Apply it with the corresponding update button.',
  '当前文档已重置，保留当前 Schema。现在可重新构建初始图。':
    'Document reset with current definitions retained. You can now build the initial graph.',
  '属性已添加，构建初始图后点击“更新 Facet”提取。':
    'Attribute added. Build the initial graph, then click Update Facet to extract it.',

  增加关系: 'Add relation',
  方向: 'Direction',
  关联单元: 'Related unit',
  选择论证单元: 'Select an argument unit',
  '当前单元 → 对方': 'This unit → Other',
  '对方 → 当前单元': 'Other → This unit',
  关系说明: 'Relation description',
  关系说明与备注: 'Description and notes',
  '可连接同段或其他段落的论证单元；所有修改在保存标注后生效。':
    'Connect units in this or other paragraphs. All changes take effect when you save the annotation.',
  '暂无关联关系。': 'No related edges yet.',
  '关系必须连接当前单元与另一个论证单元。': 'A relation must connect this unit to another argument unit.',
  '关联单元不存在或已被当前句子范围合并，请修改或删除对应关系。':
    'The related unit is missing or absorbed by the new sentence range. Edit or remove its relation.',
  '请选择有效的关系类型。': 'Select a valid relation type.',
  '关系编号重复。': 'Duplicate relation ID.',
  '补充分析未完成，已有节点仍可查看。':
    'Additional analysis did not finish. Existing nodes remain available.',
  '正在补充摘要与段内关系…': 'Updating summaries and relations within paragraphs…',
  '本地后端响应超时，请检查后端终端和任务状态。':
    'The local backend timed out. Check its terminal and the task status.',
  '无法读取本地后端响应。请检查后端终端；更新代码后请重启 npm run backend。':
    'Cannot read the local backend response. Check its terminal; after a code update, restart npm run backend.',
  '后端处理请求失败，请查看后端终端；若刚更新代码，请重启 npm run backend。':
    'The backend could not process the request. Check its terminal; after a code update, restart npm run backend.',
  '后端返回格式无效，请确认本地 API 服务地址。':
    'The backend returned an invalid response. Check the local API address.',
  '每类最多检索 250 个匹配，可分批显示。': 'Up to 250 matches per Motif, shown in batches.',
  名称: 'Name',
  总结最小论证单元: 'Summarizing argument units',
  设为焦点: 'Set as focus',
  取消焦点: 'Clear focus',
  '焦点已设置，完成宏观图构建后可按焦点更新。': 'Focus set. Build the macro graph, then update by focus.',
  '导入 Schema': 'Import Schema',
  '导出 Schema': 'Export Schema',
  'Schema 文件格式无效。': 'Invalid Schema file.',
  'Schema 已导入。已有分类会保留；同名同编号分类已更新，冲突编号已自动分配。':
    'Schema imported. Existing types are preserved; matching types are updated and conflicting IDs are reassigned.',
  切换图视图: 'Switch graph view',
  'Motif 图集': 'Motif gallery',
  '按 Motif 查看当前文档中的匹配子图，点击小图返回主图定位。':
    'Browse matched subgraphs by Motif. Click a card to locate it in the main graph.',
  '定位匹配 {n}': 'Locate match {n}',
  暂无匹配子图: 'No matching subgraphs',
  显示更多: 'Show more',
  '请先添加 Motif': 'Add a Motif to get started',

  正文: 'Body',
  'Embedding 维度不一致，请使用同一个 embedding 模型重新索引':
    'Embedding dimensions differ. Reindex with the same embedding model',
  选择文档: 'Select document',
  重新读取源文件: 'Reload source',
  '检查 Markdown 的修改并重新加载文档': 'Check Markdown changes and reload the document',
  重置当前文档: 'Reset document',
  '清除当前文章的标注、分析、缓存和任务；保留原文与当前 Schema':
    'Clear annotations, analysis, cache and tasks for this document; keep the source and current Schema',
  '{0} 项人工标注': '{0} manual annotations',
  'AI 论证分析': 'AI argument analysis',
  待分析: 'Not analyzed',
  规则预标注: 'Rule-based annotations',
  本地数据库与浏览器缓存: 'Local database and browser cache',
  浏览器缓存: 'Browser cache',
  仅本地保存: 'Saved in browser only',
  已保存: 'Saved',
  保存中: 'Saving',
  '导入 Markdown 或标注 JSON': 'Import Markdown or annotated JSON',
  导入文件: 'Import file',
  导出: 'Export',
  '工作区 JSON': 'Workspace JSON',
  'Agent 提示词': 'Agent prompt',
  'Markdown 源文件': 'Markdown source',
  工作区视图: 'Workspace views',
  正在读取文档: 'Loading document',
  重新加载: 'Reload',
  论证分析: 'Argument analysis',
  构建宏观图: 'Build macro graph',
  按Schema更新: 'Update by Schema',
  按Facet更新: 'Update by Facet',
  按焦点更新: 'Update by focus',
  '构建段落图、全量单元、属性与向量索引':
    'Build the paragraph graph, all units, attributes and embedding index',
  '按当前 Schema 重分类已有节点和边': 'Reclassify existing nodes and edges using the current Schema',
  '更新当前 Semantic Facet': 'Update the current Semantic Facet',
  '选中论证单元后，召回候选并分析局部关系':
    'Select an argument unit to retrieve candidates and analyze local relations',
  '正在提交任务…': 'Submitting task…',
  '等待执行…': 'Waiting to run…',
  已完成: 'Completed',
  已中断: 'Interrupted',
  分析失败: 'Analysis failed',
  '正在分析…': 'Analyzing…',
  '请重试任务。': 'Please retry the task.',
  宏观图与全局索引已构建: 'The macro graph and global index are ready',
  '仅更新：{name}': 'Update only: {name}',
  '，当前阶段 {0}': ', current stage {0}',
  自定义拓扑: 'Custom topology',
  收起交互面板: 'Collapse controls',
  个匹配: 'matches',
  清除拓扑筛选: 'Clear topology filter',
  '检索 Facet 实体': 'Search Facet entities',
  '检索…': 'Search…',
  '清除 Facet 检索': 'Clear Facet search',
  清除检索: 'Clear search',
  新建实体类别: 'New entity category',
  编辑实体类别: 'Edit entity category',
  '编辑 {0} · {1}': 'Edit {0} · {1}',
  语义兴趣: 'Semantic interest',
  结构化属性: 'Structured attribute',
  '{0} 个语义匹配单元': '{0} semantically matched units',
  '{0} 次出现，{1} 个论证单元': '{0} occurrences in {1} argument units',
  无匹配: 'No matches',
  暂无实体: 'No entities',
  清除实体筛选: 'Clear entity filter',
  新建节点类型: 'New node type',
  编辑节点类型: 'Edit node type',
  新建关系类型: 'New link type',
  编辑关系类型: 'Edit link type',
  新建拓扑: 'New topology',
  编辑拓扑: 'Edit topology',
  中文名: 'Name',
  英文名: 'English name',
  样式: 'Style',
  '显示{0}类型：{1}': 'Show {0} type: {1}',
  节点: 'node',
  关系: 'link',
  段落: 'Paragraph',
  检索源文本: 'Search source text',
  '检索文本…': 'Search text…',
  句: 'sentences',
  '标注段落 {0}': 'Annotate paragraph {0}',
  没有匹配的段落: 'No matching paragraphs',
  展开交互面板: 'Expand controls',
  添加关系: 'Add relation',
  全部折叠: 'Collapse all',
  全部展开: 'Expand all',
  适应画布: 'Fit to canvas',
  章节: 'chapters',
  论证单元: 'Argument unit',
  条关系: 'relations',
  历史论证图: 'Historical argument graph',
  '{0} 段落节点': '{0} paragraph node',
  折叠: 'Collapse',
  展开: 'Expand',
  个论证单元: 'Argument unit',
  '{0} {1}关系': '{0} {1} relation',
  '{0} 论证单元': '{0} argument unit',
  重试: 'Retry',
  暂无论证段落: 'No argument paragraphs',
  缩小: 'Zoom out',
  放大: 'Zoom in',
  段落关系: 'Paragraph relations',
  单元关系: 'Unit relations',
  文章叙述顺序: 'Narrative sequence',
  暂停叙述: 'Pause narrative',
  播放叙述顺序: 'Play narrative sequence',
  暂停: 'Pause',
  按文章顺序播放: 'Play in narrative order',
  上一个段落: 'Previous paragraph',
  下一个段落: 'Next paragraph',
  文章叙述进度: 'Narrative progress',
  '{0}，第 {1} / {2} 段': '{0}, paragraph {1} / {2}',
  暂无段落: 'No paragraphs',
  引言: 'Introduction',
  序: 'Intro',
  清除时间筛选: 'Clear time filter',
  时间轴: 'Timeline',
  结束年份: 'End year',
  开始年份: 'Start year',
  '{0} 个论证单元没有可识别的时间': '{0} argument units have no identifiable date',
  未定年: 'Undated',
  暂无时间: 'No dates',
  拓扑名称: 'Topology name',
  定义: 'Definition',
  描述这种论证模式的含义: 'Describe what this argument pattern means',
  节点数: 'Node count',
  关系类型: 'Link type',
  不限: 'Any',
  '关系 {0} 起点': 'Edge {0} source',
  '关系 {0} 终点': 'Edge {0} target',
  删除边: 'Delete edge',
  添加边: 'Add edge',
  支撑方式: 'Support mode',
  联合支撑: 'Joint support',
  独立支撑: 'Independent support',
  例证支撑: 'Support by example',
  类别名称: 'Category name',
  由英文名生成: 'Generated from the English name',
  'Facet 机制': 'Facet mechanism',
  'Attribute · 结构化属性': 'Attribute · Structured attribute',
  'Semantic · 语义兴趣': 'Semantic · Semantic interest',
  提取词表: 'Extraction vocabulary',
  '可选，以逗号分隔；Agent 可按定义提取': 'Optional, comma-separated; the Agent can extract by definition',
  相似度阈值: 'Similarity threshold',
  最多匹配单元: 'Maximum matched units',
  '对语义召回结果使用 LLM 复核': 'Review semantic search results with an LLM',
  颜色: 'Color',
  类型颜色: 'Type color',
  十六进制颜色: 'Hex color',
  线型: 'Line style',
  实线: 'Solid',
  虚线: 'Dashed',
  点线: 'Dotted',
  '工作区中有 {count} 处引用此分类。请选择替代分类，原有节点、边和引用内容会保留。':
    'This type has {count} references in the workspace. Choose a replacement to preserve existing nodes, edges and citations.',
  '至少保留一个{kind}类型；可先新增分类再删除。':
    'Keep at least one {kind} type. Add a new type before deleting this one.',
  替代分类: 'Replacement type',
  请选择分类: 'Select a type',
  替换并删除: 'Replace and delete',
  删除分类: 'Delete type',
  取消: 'Cancel',
  保存: 'Save',
  层级: 'Level',
  起点: 'Source',
  选择起点: 'Select source',
  终点: 'Target',
  选择终点: 'Select target',
  '联合支撑组 ID': 'Joint support group ID',
  可留空: 'Optional',
  显示摘要: 'Display label',
  '节点旁显示的简短标签，最多 20 字': 'Short label beside the node, up to 20 characters',
  '段落摘要（用于分类与关系分析）': 'Paragraph summary (for classification and relation analysis)',
  论证表示: 'Argument representation',
  论证类型: 'Argument type',
  起始句: 'First sentence',
  结束句: 'Last sentence',
  分析依据与来源: 'Evidence and provenance',
  '核性：': 'Nuclearity: ',
  '类型：': 'Type: ',
  '段落摘要引用（非原文引用）': 'Paragraph summary citations (not source quotations)',
  原文引用: 'Source quotations',
  '原文依据：': 'Source evidence: ',
  '篇章关系：': 'Discourse relation: ',
  标注备注: 'Annotation notes',
  删除关系: 'Delete relation',
  保存标注: 'Save annotation',
  关闭: 'Close',
  新建关系: 'New relation',
  编辑关系: 'Edit relation',
  论证单元标注: 'Argument unit annotation',
  段落标注: 'Paragraph annotation',
  '请填写名称。': 'Please enter a name.',
  '请添加有效关系，避免自环与重复边。': 'Add valid relations without self-loops or duplicate edges.',
  '所有节点需连成一个拓扑。': 'All nodes must form one connected topology.',
  '请填写定义。': 'Please enter a definition.',
  '请填写英文名。': 'Please enter an English name.',
  'ID 需以小写字母开头，只包含字母、数字和下划线。':
    'The ID must start with a lowercase letter and contain only letters, digits and underscores.',
  '这个 ID 已存在。': 'This ID already exists.',
  '请选择两个不同的端点。': 'Select two different endpoints.',
  '这条关系已存在。': 'This relation already exists.',
  '结束句不能在起始句之前。': 'The last sentence cannot precede the first sentence.',
  '分类不存在。': 'This type does not exist.',
  '至少保留一个分类。': 'Keep at least one type.',
  '请选择有效的替代分类。': 'Choose a valid replacement type.',
  后端请求失败: 'Backend request failed',
  '章节轮廓布局未能收敛。': 'The chapter outline layout could not converge.',
  '本地修改已恢复，等待同步。': 'Local edits restored; waiting to sync.',
  '数据库与本地标注均有变化。本地修改已保留，可导出工作区，或重置当前文档后按当前 Schema 重新构建。':
    'Both the database and local annotations have changed. Your local edits are preserved. Export the workspace, or reset this document and rebuild using the current Schema.',
  '请先启动本地后端：npm run backend': 'Start the local backend first: npm run backend',
  '分析未完成，可再次点击对应任务按钮重试。':
    'Analysis is incomplete. Click the corresponding task button to retry.',
  '读取分析进度失败，正在重新连接。': 'Could not read analysis progress. Reconnecting.',
  '浏览器存储空间不足，请导出工作区。': 'Browser storage is full. Please export the workspace.',
  'Schema 格式无效。': 'Invalid Schema format.',
  '关系线型无效。': 'Invalid link line style.',
  'Facet 格式无效。': 'Invalid Facet format.',
  'Motif 格式无效。': 'Invalid Motif format.',
  '本地缓存不可用，已加载源文件。': 'Local cache is unavailable. Loaded the source file.',
  '暂时无法检查 Markdown 源文件，当前显示已保存的版本。':
    'Cannot check the Markdown source right now. Showing the saved version.',
  'Markdown 源文件已变化，正在进行的分析仍使用原版本。任务结束后可重新读取源文件。':
    'The Markdown source has changed. The running analysis still uses the previous version. Reload the source after the task finishes.',
  'Markdown 源文件已变化。为保留已有分析或标注，当前显示已保存的版本；可导出工作区备份，再通过“导入文件”将新版 Markdown 作为新文档分析。':
    'The Markdown source has changed. Showing the saved version to preserve your analysis and annotations. Export a workspace backup, then use “Import file” to analyze the revised Markdown as a new document.',
  '没有找到文档或 Markdown 源文件。': 'No document or Markdown source file found.',
  '无法读取最新 Markdown，未重置文档。': 'Could not read the latest Markdown. The document was not reset.',
  '当前文档已重置，保留当前 Schema。现在可重新构建宏观图。':
    'Document reset. The current Schema is preserved. You can now rebuild the macro graph.',
  '后端尚未支持重置，请重启后端后重试。':
    'The running backend does not support reset yet. Restart it and retry.',
  '分析任务进行中，完成后可编辑。': 'Analysis is running. You can edit after it finishes.',
  'Schema 已保存，后续分析使用新定义。': 'Schema saved. Future analysis will use the new definitions.',
  '分析任务进行中，完成后可删除分类。': 'Analysis is running. You can delete types after it finishes.',
  '分类已删除，后续分析使用更新后的 Schema。': 'Type deleted. Future analysis will use the updated Schema.',
  标注已保存: 'Annotation saved',
  '文档 ID 不合法。': 'Invalid document ID.',
  文档已导入: 'Document imported',
  '无法加载文件目录。': 'Could not load the file list.',
  'public/data 中没有 Markdown 文档。': 'No Markdown documents in public/data.',
  '分析完成后可编辑 Schema。': 'You can edit the Schema after analysis finishes.',
  '不是有效的 ArguLoom 文档。': 'Not a valid ArguLoom document.',
  '编号必须有效且唯一。': 'IDs must be valid and unique.',
  '句子编号重复或无效。': 'Duplicate or invalid sentence IDs.',
  '论证单元引用了不存在的段落。': 'An argument unit references a missing paragraph.',
  '文本块引用了不存在的段落。': 'A text block references a missing paragraph.',
  切换界面语言: 'Switch interface language',
  总结各段并按摘要判断类型: 'Summarizing paragraphs and classifying summaries',
  按滑动窗口分析段落关系: 'Analyzing paragraph relations in sliding windows',
  切分段落内论证单元: 'Segmenting paragraphs into argument units',
  提取本地属性与时间: 'Extracting local attributes and dates',
  建立全量单元向量: 'Embedding all argument units',
  判断局部单元节点类型: 'Classifying local argument units',
  判断局部单元关系: 'Analyzing local unit relations',
  '按 Schema 更新已分类节点': 'Reclassifying existing nodes by Schema',
  '按 Schema 重分类已有边': 'Reclassifying existing edges by Schema',
  完成: 'Completed',
  排队: 'Queued',
  段落关系分析: 'Analyzing paragraph relations',
  提取属性: 'Extracting attributes',
  模型服务请求失败: 'Model service request failed',
  '服务重启，可重试任务': 'The service restarted. You can retry the task.',
  '该文档正在分析，请等待任务结束后保存。':
    'This document is being analyzed. Wait for the task to finish before saving.',
  '文档版本已变化，未覆盖数据库；请保留本地修改后同步。':
    'The document version has changed. The database was not overwritten. Preserve your local edits and sync.',
  '文档已更新，请重新发起分析。': 'The document has changed. Start a new analysis.',
  '该文档已有进行中的任务。': 'This document already has an active task.',
  该文档已有进行中的任务: 'This document already has an active task',
  只允许本地工作区访问: 'Only local workspace access is allowed',
  '文档、节点或任务不存在': 'Document, node or task not found',
  '文档 ID 不匹配': 'Document ID mismatch',
  '需要 source 和 id': 'source and id are required',
  '重置需要 Markdown 原文': 'Reset requires the Markdown source',
  至少保留一种节点类型: 'Keep at least one node type',
  仅可展开论证段落: 'Only argument paragraphs can be expanded',
  只能将论证单元设为分析焦点: 'Only argument units can be set as the analysis focus',
  '按 Facet 更新必须指定一个 Semantic Facet': 'Update by Facet requires one Semantic Facet',
  '宏观图与全局索引已完成，请使用对应更新任务':
    'The macro graph and global index are ready. Use the corresponding update task',
  仅能重试失败或中断的任务: 'Only failed or interrupted tasks can be retried',
  '文档或 schema 已修改，请发起新任务': 'The document or schema has changed. Start a new task',
  '请先构建宏观图，完成全量单元、属性与向量索引':
    'Build the macro graph first to create all units, attributes and the embedding index',
  '段落缺少 paragraph_representation，请先构建段落摘要':
    'A paragraph is missing paragraph_representation. Build paragraph summaries first',
  '单元索引缺失或原文范围已变化，请恢复有效索引后再分析焦点':
    'The unit index is missing or the source range has changed. Restore a valid index before focus analysis',
  '缺少单元向量，请先完成全量索引': 'Unit embeddings are missing. Complete the global index first',
  'Semantic facet 复核必须覆盖所有候选单元': 'Semantic facet review must cover all candidate units',
  'Semantic facet 复核缺少原文依据': 'Semantic facet review is missing source evidence',
  '聊天服务响应缺少 choices[0].message，请确认服务支持 Chat Completions 接口。':
    'The chat response is missing choices[0].message. Check that the service supports Chat Completions.',
  '聊天服务返回了无效的 tool_calls 格式。': 'The chat service returned an invalid tool_calls format.',
  '聊天服务返回的 message.content 必须是字符串。': 'The chat response message.content must be a string.',
  'Embedding 服务响应缺少 data[0].embedding，请确认地址和向量模型 ID。':
    'The Embedding response is missing data[0].embedding. Check the URL and embedding model ID.',
  '该 agent 不允许工具调用': 'This agent does not allow tool calls',
  'Facet 工具调用超出 5 轮限制': 'Facet tool calls exceeded the five-round limit',
  '总结缺少有效的 display_label / paragraph_representation':
    'The summary is missing a valid display_label / paragraph_representation',
  'node schema agent 返回未知类型': 'The node schema agent returned an unknown type',
  'argu unit agent 的句子覆盖不完整、重叠或顺序错误':
    'The argu unit agent returned incomplete, overlapping or out-of-order sentence coverage',
  '论证单元编号必须从 1 开始连续递增': 'Argument unit numbers must be consecutive, starting at 1',
  'link schema agent 缺少 edges 数组': 'The link schema agent response is missing the edges array',
  'link schema agent 返回了无效关系': 'The link schema agent returned an invalid relation',
  'Embedding 服务返回无效向量': 'The Embedding service returned an invalid vector',
  '时间提取必须返回 values 数组': 'Time extraction must return a values array',
  时间属性值或引用不是文本中的连续片段: 'A time value or citation is not a contiguous passage of the text',
  '关系重分类缺少 type': 'Relation reclassification is missing type',
  关系重分类返回未知类型: 'Relation reclassification returned an unknown type',
  '关系 evidence 必须是非空数组，每项包含 node_id 和 quote':
    'Relation evidence must be a non-empty array of node_id and quote entries',
  '缺少 document 对象': 'Missing document object',
  '图数据必须包含 paragraphs/units/edges/chapters/blocks 数组':
    'Graph data must contain paragraphs/units/edges/chapters/blocks arrays',
  '节点/关系 schema 定义或颜色无效': 'Invalid node/link schema definition or color',
  关系线型无效: 'Invalid link line style',
  'Facet 需要有效机制和定义': 'Facet requires a valid mechanism and definition',
  '语义 Facet 阈值需在 0–1，数量需在 1–100':
    'Semantic Facet threshold must be 0\u20131 and count must be 1\u2013100',
  文档格式无效: 'Invalid document format',
  '图 ID 重复': 'Duplicate graph IDs',
  段落引用不存在的章节: 'A paragraph references a missing chapter',
  段落类型或句子内容无效: 'Invalid paragraph type or sentence content',
  句子编号重复: 'Duplicate sentence IDs',
  单元必须无重叠地完整覆盖段落: 'Units must cover the entire paragraph without overlap',
  已展开段落缺少论证单元: 'An expanded paragraph has no argument units',
  '论证单元的段落/类型无效': 'An argument unit has an invalid paragraph or type',
  论证单元必须引用连续句子: 'Argument units must reference consecutive sentences',
  '关系端点、层级或类型无效': 'Invalid relation endpoints, level or type',
  文本块引用不存在的段落: 'A text block references a missing paragraph',
  'Motif 需包含 2–6 个节点及有效边': 'Motif must contain 2\u20136 nodes and valid edges',
  'Motif 边无效': 'Invalid Motif edges',
  文本: 'Text',
  原文: 'Source',
  论证模式: 'Motifs',
  拓扑结构: 'Topology',
  分析切面: 'Facets',
  '{0} 个实体': '{0} entities',
  分类体系: 'Schema',
  本体定义: 'Ontology',
  论证图: 'Graph',
  论证地图: 'Argument map',
  图视图: 'Graph',
  图集视图: 'Gallery',
  焦点: 'Focus',
  语义: 'Semantic',
  实体: 'Entity',
  时间: 'Time',
  '{0} 句': '{0} sentences',
  '分类体系版本 {0}': 'Schema version {0}',
  工作区: 'Workspace',
  新建: 'New',
  '计数：段落': '{count} paragraph{suffix}',
  '计数：章节': '{count} chapter{suffix}',
  '计数：论证单元': '{count} argument unit{suffix}',
  '计数：关系': '{count} relation{suffix}',
  '计数：匹配': '{count} match{suffix}',
  '计数：句子': '{count} sentence{suffix}',
  公元前年份: '{year} BCE',
}
